import { createRootRoute, createRoute } from '@tanstack/react-router'
import { RootLayout } from './routes/__root'
import { HomePage } from './routes/home'
import { LoginPage } from './routes/login'
import { TenantPage } from './routes/tenant'

const rootRoute = createRootRoute({ component: RootLayout })

const homeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: HomePage,
})

const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  component: LoginPage,
})

const tenantRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/tenant/$tenantId',
  component: TenantPage,
})

export const routeTree = rootRoute.addChildren([homeRoute, loginRoute, tenantRoute])
